var React = require('react');

function ArrowRightBlack (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:none;stroke:#1A1A1A;stroke-width:2;}\n"),React.createElement("g",{"id":"arrowrightblack_Group_823","transform":"translate(-929.733 -3520.235)","key":1},[React.createElement("path",{"id":"arrowrightblack_Path_15","className":"st0","d":"M939.2,3532.7l5.9-5.9l-5.9-5.9","key":0}),React.createElement("line",{"id":"arrowrightblack_Line_68","className":"st0","x1":"944.7","y1":"3526.8","x2":"929.7","y2":"3526.8","key":1})])]);
}

ArrowRightBlack.defaultProps = {"version":"1.1","id":"arrowrightblack_Layer_1","x":"0px","y":"0px","viewBox":"0 0 16.8 13.2","style":{"enableBackground":"new 0 0 16.8 13.2"},"xmlSpace":"preserve"};

module.exports = ArrowRightBlack;

ArrowRightBlack.default = ArrowRightBlack;
